import { render, staticRenderFns } from "./Carrinho.vue?vue&type=template&id=bccf7324&"
import script from "./Carrinho.vue?vue&type=script&lang=js&"
export * from "./Carrinho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports